/**
 * @generated SignedSource<<8ea3ec79783727a8be1293ed0ee40451>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addExtraOptionPanel_ListQuery$variables = Record<PropertyKey, never>;
export type addExtraOptionPanel_ListQuery$data = {
  readonly myAdditionalAttributes: ReadonlyArray<{
    readonly additionalAttributeID: number;
    readonly id: string;
    readonly name: string | null;
  }>;
};
export type addExtraOptionPanel_ListQuery = {
  response: addExtraOptionPanel_ListQuery$data;
  variables: addExtraOptionPanel_ListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "status",
        "value": 0
      }
    ],
    "concreteType": "AdditionalAttribute",
    "kind": "LinkedField",
    "name": "myAdditionalAttributes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalAttributeID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": "myAdditionalAttributes(status:0)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addExtraOptionPanel_ListQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addExtraOptionPanel_ListQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "ead36ee2a13d467f098da71ac0322c10",
    "id": null,
    "metadata": {},
    "name": "addExtraOptionPanel_ListQuery",
    "operationKind": "query",
    "text": "query addExtraOptionPanel_ListQuery {\n  myAdditionalAttributes(status: 0) {\n    id\n    additionalAttributeID\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "51ca6a12804cfd4222d67a5fc5c002da";

export default node;
